import { render, staticRenderFns } from "./ResendInvitationDialog.vue?vue&type=template&id=ebcff21c&"
import script from "./ResendInvitationDialog.vue?vue&type=script&lang=js&"
export * from "./ResendInvitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports